<div class="rightComp">
    <div class="col-12 progressTracker" *ngIf="enforcementDetail && enforcementDetail.length > 0">
      <div class="trackerTitle mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
        <span *ngIf="!isArabic">Submitted Enforcement : </span>
        <span *ngIf="isArabic">خطط العمل المقدمة:</span>
      </div>
  
      <table class="table table-striped table-bordered customTable">
        <thead>
          <tr>
            <th>Assessment Name</th>
            <th>Inspection</th>
            <th>Action</th>
            <th>Violation</th>
            <th>Enforcement</th>
            <th class="midAlign">Overall Status</th>
            <th class="midAlign">#</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of enforcementDetail; let i = index">
            <td>{{ item.mde_AssessmentEntity.name }}</td>
            <td>{{ item.mde_InspectionPlan.mde_name }}</td>
            <td>{{ item.mde_actionitem?.mde_name }}</td>
            <td>{{ item.mde_Violation?.mde_name }}</td>
            <td>{{ item.mde_name }}</td>
           <td class="midAlign">{{ 
              item.mde_enforcementstatus === 755020000 ? 'Active' : 
              item.mde_enforcementstatus === 755020001 ? 'Closed' : 
              item.mde_enforcementstatus === 755020002 ? 'Cancelled' : 
              item.mde_enforcementstatus === 755020003 ? 'Draft' : 
              item.mde_enforcementstatus === 755020004 ? 'Paid' : 
              item.mde_enforcementstatus === 755020005 ? 'Partially Paid' : 
              item.mde_enforcementstatus === 755020006 ? 'Void' : 
              '' 
            }}</td>
            <td class="midAlign">
              <button value="{{item.mde_enforcementid}}" (click)="goToDetail(item.mde_enforcementid)" class="showTxt">
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
     <div *ngIf="!enforcementDetail || enforcementDetail.length === 0">
      <span *ngIf="!isArabic">No enforcement history found.</span>
      <span *ngIf="isArabic">لم يتم العثور على أي سجل إنفاذ.</span>
    </div>
  </div>
  